import { Artist } from '../types/Artist';
import { Campaign } from '../types/Campaign';
import { Data } from 'react-firebase-hooks/firestore/dist/firestore/types';

export const campaignURL = (
  c: Data<Campaign, 'id', 'ref'>,
  a: Data<Artist, 'id', 'ref'>,
): string => `/artists/${a.slug || a.id}/campaigns/${c.id}`;
